import { startCase } from "lodash";
import { formatDefaultDate } from "../../../../../utils/DateUtils";

export const renderSurgicalHistoryEntry = (entry) => {
  const parts = [];
  const { status, performedPeriod, code, reasonCode, note, complication } =
    entry;
  if (performedPeriod && (performedPeriod.start || performedPeriod.end)) {
    parts.push(
      formatDefaultDate(
        new Date(
          performedPeriod.start ? performedPeriod.start : performedPeriod.end,
        ),
        performedPeriod.extension?.[0]?.valueCode,
      ),
    );
  }

  if (code) {
    parts.push(code.text);
  }

  if (reasonCode) {
    parts.push(reasonCode.map((r) => r?.text));
  }

  if (status) {
    parts.push(startCase(status));
  }

  if (complication && complication.length > 0) {
    parts.push(
      `${complication.length} complication${complication.length > 1 ? "s" : ""}`,
    );
  }

  if (note?.length > 0) {
    note.forEach((n) => {
      parts.push(`${n.text}`);
    });
  }
  return <>{`⚬ ${parts.join(" · ")}`}</>;
};
